import messages from '../locales/ru_RU.json';

const lang = {
    messages: {
        ...messages,
    },
    locale: 'ru-RU',
};
export default lang;
